import { useCallback } from 'react';

import { isNotNull } from 'utils/tsHelpers';

import { useQueryStateContext } from '../../contexts/queryState';
import { useQueryHistoryStateContext } from '../../contexts/queryHistory';
import { Combinator } from '../../types';

export const useQueryCombinatorState = () => {
  const {
    query: { combinator: queryCombinator },
    setQuery,
  } = useQueryStateContext();
  const { addToUndoStack } = useQueryHistoryStateContext();
  const setQueryCombinator = useCallback(
    (newQueryCombinator: Combinator | null) => {
      setQuery((query) =>
        isNotNull(newQueryCombinator) ? { ...query, combinator: newQueryCombinator } : query,
      );
      addToUndoStack();
    },
    [setQuery],
  );
  return { queryCombinator, setQueryCombinator };
};
